import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AnyFunction = (...args: any[]) => void;

export const useDebounceEffect = <T extends AnyFunction>(callback: T | undefined, delay = 300) => {
  const handler = React.useRef<ReturnType<typeof setTimeout>>();
  return (...v: Parameters<T>) => {
    if (!callback) return;
    clearTimeout(handler.current);
    handler.current = setTimeout(() => {
      callback(...v);
    }, delay);
  };
};
